<template>
  <div :class="componentClassName">
    <a-page-heading>FD/ND番号管理 </a-page-heading>
    <m-section>
      <m-action-card id="numberMgmtFdnd" :title="`FD/ND番号一覧 （${numberList.length}）`" icon="user-setting">
        <m-form-input>
          <a-select-field id="serviceList" v-model="selectedService" :options="serviceList" />
          <a-button
            id="displayBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="表示"
            @click="handlerGetNumberInfo(true)"
          />
          <a-button
            id="uploadFDNDNumberBtn"
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="FDND予約番号アップロード"
            style="margin-left: 0.2em"
            @click="
              csvUploadModal.visible = true;
              csvUploadModal.screen = 1;
              handlerGetNumberInfo();
            "
          />
          <br /><br />
        </m-form-input>
        <!-- <br /><br />
        <m-form-input>
          <a-upload-field
            v-model="currentUploadFile.file"
            label="CSVファイルを選択してください"
            accept="text/csv"
            style="width: 500px; height: 100px"
            @change="handleFileUploadChange(currentUploadFile)"
          />
          <a-button
            :inline="true"
            variant="fill"
            color="primary"
            size="medium"
            label="送信"
            style="width: 100px"
            @click="handleUploadCsv()"
          />
        </m-form-input> -->
        <br /><br />
        <m-data-table ref="dataTable" :empty-text="dataTableEmptyText" :fit="true" :data="numberList">
          <a-data-table-column prop="numberView" :min-width="120" label="番号" align="left" :filterable="true">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('numberView', 'asc')"
                :handle-sort-descending="() => handleSort('numberView', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="statusName"
            :min-width="120"
            label="番号ステータス"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                ref="statusFilter"
                variant="filter"
                :data-list="statusFilterDataList"
                :selected-items="checkedStatus"
                :handle-filter-cancel="() => handleFilterCancel('statusName')"
                :handle-filter-confirm="data => handleFilterConfirm('statusName', data, 0)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="updateDate"
            :min-width="120"
            label="ステータス更新日"
            align="left"
            :filterable="true"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('updateDate', 'asc')"
                :handle-sort-descending="() => handleSort('updateDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column :min-width="120" label="番号登録方法" align="left">
            <template #default="scope">
              {{ scope.row.typeName }}
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <!-- CSVアップロードモーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmtFdmd_csvUploadModal"
      :visible="csvUploadModal.visible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div v-if="csvUploadModal.screen === 1">
        <p>予約番号対象が下記のサービス/番号帯で 正しいことを確認し、CSVファイルを アップロードしてください。</p>
        <br />
        <a-text :center="true">
          <span>対象サービス/番号帯： </span>
          <span style="font-weight: bolder; color: orange">{{ `${serviceName} ${numberBand}` }}</span>
        </a-text>
      </div>
      <div v-if="csvUploadModal.screen === 2">
        <p>以下の登録内容でよろしければOKボタンを押してください。</p>
        <br />
        <a-text :center="true">
          <p>サービス名：{{ serviceName }}</p>
          <p>番号帯：{{ numberBand }}</p>
          <p>登録件数：{{ currentCsvData.length }}</p>
        </a-text>
      </div>
      <div v-if="csvUploadModal.screen === 3">
        <a-text :center="true">
          <span>番号の登録が正常に行われました。</span>
        </a-text>
      </div>
      <div v-if="csvUploadModal.screen === 4">
        <a-text :center="true">
          <span>登録できない番号が含まれています。CSVファイルを修正してください。</span>
        </a-text>
      </div>
      <template #footer>
        <label v-if="csvUploadModal.screen === 1" class="custom-file-upload">
          <input
            id="csvUploadModalFileInput"
            ref="csvInputRef"
            type="file"
            class="a-upload-field__input"
            @change="handleFileUploadChange"
          />
          <span class="a-button a-button--block a-button--color-primary a-button--small">CSVアップロード</span>
        </label>
        <a-button
          v-if="csvUploadModal.screen === 2"
          id="csvUploadModalScreen2OKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleUploadCsv()"
        />
        <a-button
          id="csvUploadModalCloseBtn"
          variant="block"
          color="primary"
          label="閉じる"
          size="small"
          @click="csvUploadModal.visible = false"
        />
      </template>
    </o-modal>
  </teleport>
  <!-- モーダル -->
  <teleport to="body">
    <o-modal
      id="numberMgmtFdnd_resultModal"
      :visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="resultModalOKBtn"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import ASelectField from '@/components/atoms/select-field';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import MFilterDialog from '@/components/molecules/filter-dialog';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-number-mgmt-fdnd',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    ASelectField,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
    MFilterDialog,
  },
  mixins: [customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      currentPage: 1,
      parPage: 20,
      POINT,
      // 電話番号情報(表示用)
      numberList: [],
      // 電話番号ステータス一覧
      numberStatusName: {
        ready: '払い出し可能',
        allocated: '利用中',
        unavailable: '利用不可',
      },
      fdndVisible: false,
      currentFdndNumber: '',
      noteVisible: false,
      currentNote: '',
      currentEditContentNumber: '',
      currentEditCompanyID: '',
      filter: {},
      filterColumn: '',
      filterSort: '',
      filterList: [],
      statusFilterDataList: [],
      checkedStatus: [],
      selectedService: 'ccc_0120',
      serviceList: [
        {
          label: 'COTOHA Call Center - 0120番号',
          value: 'ccc_0120',
        },
        {
          label: 'COTOHA Call Center - 0800番号',
          value: 'ccc_0800',
        },
        {
          label: 'COTOHA Call Center - 0570番号',
          value: 'ccc_0570',
        },
        {
          label: 'COTOHA Voice DX Basic (着信) - 0120番号',
          value: 'voicedx_inbound_0120',
        },
        {
          label: 'COTOHA Voice DX Basic (着信) - 0800番号',
          value: 'voicedx_inbound_0800',
        },
        {
          label: 'COTOHA Voice DX Basic (着信) - 0570番号',
          value: 'voicedx_inbound_0570',
        },
      ],
      currentSort: {},
      currentFilter: {},

      currentUploadFile: {
        file: '',
        binary: null,
      },
      currentCsvData: null,
      fdndTypeName: {
        manually: '手動登録',
        automatically: 'システム払出',
      },
      csvUploadModal: {
        visible: false,
        screen: 0,
      },
      inStockNumbers: [],
      dataTableEmptyText: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-number-mgmt-fdnd');
      return `${baseClassName} ${this.class}`.trim();
    },
    serviceName() {
      if (!this.selectedService) return '';
      if (this.selectedService.indexOf('ccc') !== -1) return 'COTOHA Call Center';
      return 'COTOHA Voice DX Basic (着信)';
    },
    numberBand() {
      if (!this.selectedService) return '';
      return this.selectedService.split('_')[this.selectedService.split('_').length - 1];
    },
  },
  created() {
    if (this.companyID !== POINT) {
      this.$router.push({
        path: '/permission-denied',
      });
    }
  },
  async mounted() {
    if (this.companyID === POINT) {
      this.selectedCompanyID = POINT;
      this.fetchCompanyIDListHandler();
    }
    if (this.$route.query.companyID) {
      this.selectedCompanyID = this.$route.query.companyID;
    } else {
      await this.handlerGetNumberInfo(true);
    }
  },
  methods: {
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlist')
        .then(e => {
          this.companyIDList = e.data;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.numbermgmtGetCompanyIdError);
        });
    },
    handlerGetNumberInfo: async function (initialize, sortInfo = null, filterInfo = null) {
      await this.postRequest('/numbermgmt/getFdndList', {
        companyID: this.$route.query.companyID,
        selectedService: this.selectedService,
      })
        .then(e => {
          this.inStockNumbers = [];
          let numberListArr = e.data;
          // ステータスを日本語表記に変換
          for (const numberInfo of numberListArr) {
            this.inStockNumbers.push(numberInfo.number);
            // 050番号ステータス
            if (this.numberStatusName[numberInfo.status]) {
              numberInfo.statusName = this.numberStatusName[numberInfo.status];
            } else {
              numberInfo.statusName = numberInfo.status;
            }
            // FDND番号の種類表記
            if (this.fdndTypeName[numberInfo.type]) {
              numberInfo.typeName = this.fdndTypeName[numberInfo.type];
            } else {
              numberInfo.typeName = numberInfo.type;
            }
          }

          // 電話番号の+81を0に変換
          for (const numberInfo of numberListArr) {
            if (numberInfo.number) {
              numberInfo.numberView = numberInfo.number.replace('+81', '0');
            }
          }

          // FD/ND番号が空白の場合、「未設定」と表示
          for (const numberInfo of numberListArr) {
            if (numberInfo.customerFDNDNumber) {
              numberInfo.customerFDNDNumberView = numberInfo.customerFDNDNumber;
            } else {
              numberInfo.customerFDNDNumberView = '未設定';
            }
          }

          // undefinedのプロパティを空文字に変換
          numberListArr = this.checkNumberListProp(numberListArr);

          // 表示されているステータス名のフィルター項目を作成
          this.statusFilterDataList = this.getNumberStatusQueryList(numberListArr);

          // 初期化フラグがtrueの場合はソート・フィルタ条件をクリア
          if (initialize === true) {
            this.currentSort = {};
            this.currentFilter = {};
            sortInfo = null;
            filterInfo = null;
          }

          // ソート・フィルターが指定されている場合
          if (sortInfo || filterInfo) {
            if (filterInfo.length > 0) {
              let resultList = [];
              for (let idx = 0; idx < filterInfo.length; ++idx) {
                const addNumberInfo = numberListArr.filter(numberInfo => numberInfo.statusName === filterInfo[idx]);
                resultList = resultList.concat(addNumberInfo);
              }
              // 検索結果が0件の場合
              if (resultList.length === 0) {
                this.dataTableEmptyText = messageContent.numbermgmtDataTableEmptyText;
              }
              numberListArr = resultList;
              // ダイアログを閉じる
              const columnIndex = this.getFilterColumnIndex('statusName');
              if (columnIndex !== -1) {
                this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
              }
            } else {
              // ダイアログを閉じる
              const columnIndex = this.getFilterColumnIndex('statusName');
              if (columnIndex !== -1) {
                this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
              }
            }
            if (sortInfo) {
              if (sortInfo.dir === 'asc') {
                numberListArr.sort((a, b) => {
                  if (a[sortInfo.prop] < b[sortInfo.prop]) return -1;
                  if (a[sortInfo.prop] > b[sortInfo.prop]) return 1;
                  return 0;
                });
              } else if (sortInfo.dir === 'desc') {
                numberListArr.sort((a, b) => {
                  if (a[sortInfo.prop] > b[sortInfo.prop]) return -1;
                  if (a[sortInfo.prop] < b[sortInfo.prop]) return 1;
                  return 0;
                });
              }
              const columnIndex = this.getFilterColumnIndex(sortInfo.prop);
              if (columnIndex !== -1) {
                this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
              }
            }
          } else {
            // 選択済みステータスのフィルタをクリア
            this.$refs.statusFilter.handleClearClick();
          }

          this.numberList = numberListArr;
        })
        .catch(() => {
          this.showErrorModal(messageContent.numbermgmtGetNumberError);
        });
    },
    handleSort(prop, dir) {
      this.currentSort = {
        prop: prop,
        dir: dir,
      };
      this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    // undefinedとなるプロバティに空文字を挿入(ソートを行うため)
    checkNumberListProp(list) {
      for (const obj of list) {
        if (!obj.companyID) {
          obj.companyID = '';
        }
        if (!obj.number) {
          obj.number = '';
        }
        if (!obj.numberView) {
          obj.numberView = '';
        }
        if (!obj.customerFDNDNumber) {
          obj.customerFDNDNumber = '';
        }
        if (!obj.customerFDNDNumberView) {
          obj.customerFDNDNumberView = '';
        }
        if (!obj.updateDate) {
          obj.updateDate = '';
        }
        if (!obj.status) {
          obj.status = '';
        }
        if (!obj.statusName) {
          obj.statusName = '';
        }
        if (!obj.note) {
          obj.note = '';
        }
        if (!obj.type) {
          obj.type = '';
        }
        if (!obj.typeName) {
          obj.typeName = '';
        }
      }
      return list;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleFilterConfirm(prop, propName, cnt) {
      this.currentFilter = propName;
      this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
    },
    getNumberStatusQueryList(list) {
      const labelList = [];
      const resultList = [];
      for (const obj of list) {
        if (obj.statusName) {
          labelList.push(obj.statusName);
        }
      }
      const queryList = Array.from(new Set(labelList));
      for (const labelText of queryList) {
        resultList.push({
          label: labelText,
          value: labelText,
        });
      }
      return resultList;
    },
    fdndNumberCheck(number, selectedService) {
      if (selectedService === 'ccc_0120' || selectedService === 'voicedx_inbound_0120') {
        // 数字以外の文字チェック
        if (!this.numberOnly(number)) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndNumberOnly0120,
          };
        }
        // 「0120」から始まるかチャック
        if (!number.startsWith('0120')) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndInitialCheck0120,
          };
        }
        // 10桁かチェック
        if (number.length !== 10) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0120,
          };
        }
        return { status: true };
      } else if (selectedService === 'ccc_0800' || selectedService === 'voicedx_inbound_0800') {
        // 数字以外の文字チェック
        if (!this.numberOnly(number)) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndNumberOnly0800,
          };
        }
        // 「0800」から始まるかチャック
        if (!number.startsWith('0800')) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndInitialCheck0800,
          };
        }
        // 11桁かチェック
        if (number.length !== 11) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0800,
          };
        }
        return { status: true };
      } else if (selectedService === 'ccc_0570' || selectedService === 'voicedx_inbound_0570') {
        // 数字以外の文字チェック
        if (!this.numberOnly(number)) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndNumberOnly0570,
          };
        }
        // 「0570」から始まるかチャック
        if (!number.startsWith('0570')) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndInitialCheck0570,
          };
        }
        // 10桁かチェック
        if (number.length !== 10) {
          return {
            status: false,
            message: messageContent.numbermgmtFdndCheck0570,
          };
        }
        return { status: true };
      } else {
        return {
          status: false,
          message: messageContent.numbermgmtFdndCheckAll,
        };
      }
    },
    handleUploadCsv() {
      this.postRequest('/numbermgmt/setFdndNumber', {
        csvData: this.currentCsvData,
        selectedService: this.selectedService,
      })
        .then(async e => {
          if (e.status === 'success') {
            // this.showInfoModal('FD/ND番号をアップロードしました。');
            this.csvUploadModal.screen = 3;
            await this.handlerGetNumberInfo(false, this.currentSort, this.currentFilter);
          } else {
            throw new Error('failed');
          }
        })
        .catch(err => {
          this.csvUploadModal.visible = false;
          this.showErrorModal(messageContent.numbermgmtFdndUploadError);
        });
    },
    validateCsvData() {
      // ファイル未選択
      if (!this.currentCsvData) {
        // this.showErrorModal('ファイルが未選択です。アップロードするCSVを選択してください。');
        return false;
      }
      //ファイルの内容が空
      if (this.currentCsvData.length === 0) {
        // this.showErrorModal('ファイルの内容が空です。FD/ND番号を改行で区切ったデータを入力してください。');
        return false;
      }
      if (this.currentCsvData.length > 20) {
        // this.showErrorModal('番号数は最大20件です。');
        return false;
      }
      for (const data of this.currentCsvData) {
        // 特殊文字チェック
        if (this.hasSpecialCharacterInString(data)) {
          // this.showErrorModal(messageContent.hasSpecialCharacter);
          return false;
        }
        // FDND番号チェック
        const fdndCheckResult = this.fdndNumberCheck(data, this.selectedService);
        if (fdndCheckResult.status === false) {
          // this.showErrorModal(fdndCheckResult.message);
          return false;
        }
        if (this.inStockNumbers.includes(data)) {
          // this.showErrorModal(`既に${data}が積み込まれていた`);
          return false;
        }
      }
      return true;
    },
    handleFileUploadChange(e) {
      const self = this;
      const reader = new FileReader();

      if (e.target.files[0] && e.target.files[0] instanceof Blob) {
        reader.readAsText(e.target.files[0]);
      } else {
        self.currentUploadFile.file = null;
        self.currentUploadFile.binary = null;
      }

      reader.onload = () => {
        self.currentUploadFile.binary = reader.result;
        self.currentCsvData = self.csv2array(self.currentUploadFile.binary);
        const validationResult = self.validateCsvData();
        if (!validationResult) {
          self.csvUploadModal.screen = 4;
          self.clearInputCsvFile();
        } else {
          self.csvUploadModal.screen = 2;
        }
      };
      reader.onerror = () => {
        console.error(reader.error);
        self.csvUploadModal.visible = false;
        self.clearInputCsvFile();
        this.showErrorModal(messageContent.numbermgmtCsvUploadError);
      };
    },
    clearInputCsvFile() {
      const inputRef = this.$refs.csvInputRef;
      if (inputRef) {
        inputRef.value = '';
        inputRef.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    csv2json(csvData) {
      const resultJson = [];
      const csvDataArr = csvData.split(/\r?\n/);
      const keyNameArr = csvDataArr[0].split(',');
      for (let idx = 1; idx < csvDataArr.length; ++idx) {
        const lineArr = csvDataArr[idx].split(',');
        const lineObj = {};
        if (lineArr.length > 0) {
          for (let keyIdx = 0; keyIdx < keyNameArr.length; ++keyIdx) {
            lineObj[keyNameArr[keyIdx]] = lineArr[keyIdx];
          }
          resultJson.push(lineObj);
        }
      }
      return resultJson;
    },
    csv2array(csvData) {
      const csvDataArr = csvData.split(/\r?\n/);
      const resultDataArr = [];
      // 空白行があれば削除
      for (const line of csvDataArr) {
        if (line.length > 0) {
          resultDataArr.push(line);
        }
      }
      return resultDataArr;
    },
  },
};
</script>
